module.exports = __webpack_public_path__ + "media/images/shark/Shark3-p-800-58aa8ac3b5928feb4b0507b85745588d.png";